import Swiper from 'swiper/bundle'
import 'swiper/swiper-bundle.min.css'
import { BenQuery } from './BenQuery'
import { BenFn } from '@/common/BenFn'

export class BenSwiper {
  static init(selector: HTMLElement, { spaceBetween = 0, loop = false, pagination, prevEl, nextEl, perView = 'auto', effect }) {
    const isMobile = BenFn.isMobileByWidth()
    const slidesPerView = isMobile ? '1' : perView
    spaceBetween = isMobile ? 0 : spaceBetween
    const swiper = new Swiper(selector, {
      effect,
      spaceBetween,
      slidesPerView,
      loop,
      pagination: { el: pagination, clickable: true },
      navigation: { nextEl, prevEl },
    })
    swiper.on('click', function (swiper, event) {
      return
      const target = event.target
      const openImage = target.getAttribute('open-image')
      if (!openImage) return
      const src = target.getAttribute('src')
      if (!src) return
      window.open(src)
    })
    return swiper
  }

  static initCoverflow(selector: HTMLElement, { spaceBetween = 0, loop = true, pagination, prevEl, nextEl, perView = 'auto' }) {
    let activeIndex = 0
    const isMobile = BenFn.isMobileByWidth()
    const slidesPerView = isMobile ? '1' : perView
    spaceBetween = isMobile ? 0 : spaceBetween
    const swiper = new Swiper(selector, {
      effect: 'coverflow',
      grabCursor: false,
      centeredSlides: true,
      loop,
      spaceBetween,
      slidesPerView,
      slideToClickedSlide: true,
      coverflowEffect: { rotate: 0, stretch: 0, depth: 100, modifier: 2.5 },
      pagination: { el: pagination, clickable: true },
      navigation: { nextEl, prevEl },
    })
    swiper.on('click', function (swiper, event) {
      const target = event.target
      const openImage = target.getAttribute('open-image')
      if (!openImage) return
      const src = target.getAttribute('src')
      if (!src) return
      const $slide = event.target.closest('.swiper-slide')
      const index = Number($slide.getAttribute('data-swiper-slide-index'))
      if (index === activeIndex) window.open(src)
    })
    swiper.on('slideChange', async (swiper, event) => {
      await BenQuery.sleep(30)
      activeIndex = swiper.realIndex
    })
    return swiper
  }
}
